import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center justify-space-between"},[(_vm.hideButton)?_c('div',{staticStyle:{"width":"24px"}}):_c(VBtn,{attrs:{"fab":"","color":"primary","height":"42px","width":"42px","disabled":_vm.loading},on:{"click":function($event){return _vm.onClickBtn()}}},[_c(VIcon,{attrs:{"color":"white","size":"28"}},[_vm._v(_vm._s(_vm.icon))])],1),_c('p',{staticClass:"mb-0 text-center",class:{
			'text-h6': _vm.isMobile,
			'text-h5': !_vm.isMobile,
			'font-weight-medium': !_vm.isMobile,
		},domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticStyle:{"width":"24px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }